module.exports = __webpack_public_path__ + "media/customizations/serranoeldorado/logo-aa3bbb0c10fcd6777b4a6ce514b83ba8.png";